import { render } from "./PublicDatasetCard.vue?vue&type=template&id=071f846c&scoped=true"
import script from "./PublicDatasetCard.vue?vue&type=script&lang=js"
export * from "./PublicDatasetCard.vue?vue&type=script&lang=js"

import "./PublicDatasetCard.vue?vue&type=style&index=0&id=071f846c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071f846c"]])

export default __exports__